import { Divider, Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import PersonIcon from '@material-ui/icons/Person';

const ShareFlagsCreateGroupSelectedUserList = ({
  userItem,
  allUsers,
  itemInfo
}) => {
  const { index, listLength } = itemInfo;

  const renderUser = () => {
    const userInfo = allUsers.filter(
      (item) => item.userId === parseInt(userItem?.value, 10)
    );
    return userInfo[0];
  };

  useEffect(() => {
    renderUser();
  }, []);

  return (
    <>
      <div className="share-flags-modal__user-group-list-item">
        <Grid className="list-item-container" container>
          <Grid item xs={12} className="list-item-user-info">
            <figure>{<PersonIcon style={{ fontSize: 20 }} />}</figure>
            <span className="list-title">{renderUser()?.name}</span>
          </Grid>
          <Grid item></Grid>
        </Grid>
      </div>
      {index !== listLength - 1 && (
        <Divider
          className="share-flags-modal__divider"
          variant="middle"
          style={{ marginBottom: '6px' }}
        />
      )}
    </>
  );
};

export default ShareFlagsCreateGroupSelectedUserList;
